export const CONSTANTS = {
  AUTHOR: "Amirmahdi Zarei",
  AUTHOR_GITHUB_LINK: "https://4mir.ir",
  PROJECT_GITHUB_LINK: "https://4mir.ir",
  AUTHOR_PORTFOLIO_LINK: "https://4mir.ir",
  GITHUB_API_BASE_URL: "https://api.github.com",
  REPO_OWNER: "z4r3i",
  REPO_NAME: "lofi-music-website",
};
